import React from "react";
import Field from "@/components/post-ad/Field";

/**
 * Site-wide 5-tier condition picker (Iter-232). Values map 1:1 to the
 * backend canonical scale:
 *   brand-new · like-new · excellent · good · fair
 *
 * Legacy "new" and "used" remain valid backend aliases so already-shipped
 * pods keep working. When editing a listing saved under the old scale we
 * highlight the corresponding new-tier so sellers can re-save without
 * losing their pick.
 */
const TILES = [
  { value: "brand-new", label: "Brand New" },
  { value: "like-new", label: "Like New" },
  { value: "excellent", label: "Excellent" },
  { value: "good", label: "Good" },
  { value: "fair", label: "Fair" },
];

const ALIAS = { new: "brand-new", used: "good" };

export function normaliseCondition(v) {
  if (!v) return null;
  const s = String(v).toLowerCase();
  if (ALIAS[s]) return ALIAS[s];
  return TILES.some((t) => t.value === s) ? s : null;
}

export default function ConditionTiles({ value, onChange, testIdPrefix = "post-ad-condition", label = "Condition", required = false }) {
  const active = normaliseCondition(value);
  return (
    <Field label={required ? `${label} *` : label}>
      <div
        className="grid grid-cols-2 sm:grid-cols-5 gap-2"
        role="radiogroup"
        aria-label="Condition"
        data-testid={`${testIdPrefix}-group`}
      >
        {TILES.map((t) => {
          const on = active === t.value;
          return (
            <button
              key={t.value}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => onChange(on ? null : t.value)}
              data-testid={`${testIdPrefix}-${t.value}`}
              className={`rounded-2xl px-3 py-2.5 text-xs sm:text-sm font-semibold border transition-colors text-center ${
                on
                  ? "bg-[color:var(--brand-blue)] text-white border-transparent shadow-sm"
                  : "bg-white text-slate-700 border-soft hover:border-[color:var(--brand-blue)]"
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>
    </Field>
  );
}
